export default __webpack_public_path__ + "static/media/faelin.9932ae7c.webp";